<template>
  <div>
    <vue-headful title="Credimóvil | Cotiza tu crédito"/>
    <menu-component></menu-component>

    <!-- Banner Area -->
    <section class="banner_area banner_area_5">
    	<div class="container">
    		<h7>Conoce el plan de crédito y solicítalo en línea</h7>
    		<h2>Cotiza tu crédito</h2>
    		<ol class="breadcrumb">
                <li></li>
                <li></li>
            </ol>
    	</div>
    </section>
    <!-- Banner Area -->

    <!-- Easy cash Area -->
    <section class="easy_cash_area cot-credict">
        <div class="container">
            <div class="row">
                <div class="col-lg-7 back-form">
                    <form class="from_main" action="php/contact.php" method="post" id="phpcontactform" novalidate="novalidate">
                        <div class="row">
                            <div class="col-lg-12 select_from">
                                <h6>¿Ingreso libre mensual?*</h6>
                                <input type="text" class="post_select" id="ingreso" name="ingreso" 
                                      v-model="masck.monthlyIncome" v-mask="numberMask" 
                                      :class="{ 'error': $v.form.monthlyIncome.$dirty && $v.form.monthlyIncome.$invalid }" required
                                      @blur="$v.form.monthlyIncome.$touch();  form.monthlyIncome = masck.monthlyIncome.replace(/\D+/g, '');">
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>¿Dependientes económicos?*</h6>
                                <input type="text" class="post_select" id="dependientes" name="dependientes" 
                                      v-model="masck.dependent" v-mask="numberMask" 
                                      :class="{ 'error': $v.form.dependent.$dirty && $v.form.dependent.$invalid }" required
                                      @blur="$v.form.dependent.$touch(); form.dependent = masck.dependent.replace(/\D+/g, '');">
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>¿Cuánto cuesta el vehículo?*</h6>
                                <input type="text" class="post_select" id="precio" name="precio" 
                                      v-model="masck.vehiclePrice" v-mask="numberMask" 
                                      :class="{ 'error': $v.form.vehiclePrice.$dirty && $v.form.vehiclePrice.$invalid }" required
                                      @blur="$v.form.vehiclePrice.$touch(); 
                                             form.vehiclePrice = masck.vehiclePrice.replace(/\D+/g, '');
                                             masck.vehicleHitch = (form.vehiclePrice/100)*20"/>
                            </div>
                            <div class="col-lg-12 select_from">
                                <h6>¿Cuanto deseas dar de enganche?*</h6>
                                <input type="text" class="post_select" id="enganche" name="enganche" 
                                      v-model="masck.vehicleHitch" v-mask="numberMask" 
                                      :class="{ 'error': $v.form.vehicleHitch.$dirty && $v.form.vehicleHitch.$invalid }" required
                                      @input="$v.form.vehicleHitch.$touch();
                                              form.vehicleHitch = masck.vehicleHitch.replace(/\D+/g, '');
                                              porcentaje = ( form.vehicleHitch / form.vehiclePrice ) * 100">
                                <div class="col-8">
                                  <span><small>Se necesita mínimo el <b>20%</b> de enganche</small> </span>  
                                </div> 
                                <div class="col-4 p-2">
                                  <span class="d-flex flex-column align-items-end ">
                                    <b :class="{'text-danger': porcentaje.toFixed(2) < 20.00 ||  porcentaje.toFixed(2) > 100,'d-none': porcentaje.toFixed(2) == 'NaN',
                                               'text-success': porcentaje.toFixed(2) >= 20.00 &&  porcentaje.toFixed(2) <= 100}">
                                               {{this.porcentaje.toFixed(2)}}%
                                    </b>    
                                  </span>   
                                </div>       
                                <div class="col-12 row" >            
                                  <input class="col-12 p-0" type="range" v-model="form.vehicleHitch"                                    
                                        :disabled="porcentaje.toFixed(2) == 'NaN'"
                                        :min="(form.vehiclePrice/100)*20" :max="form.vehiclePrice" autocomplete="off"
                                        @input="masck.vehicleHitch = form.vehicleHitch;
                                                  porcentaje = ( form.vehicleHitch / form.vehiclePrice ) * 100"/>
                                  <div class="col-6">
                                    <span><b>{{(form.vehiclePrice/100)*20 | VMask(numberMask)}}</b></span>
                                  </div>
                                  <div class="col-6 p-0">
                                    <span class="d-flex flex-column align-items-end ">
                                      <b class="align-self-end">{{masck.vehiclePrice}}</b>
                                    </span>
                                  </div>
                                </div>
                            </div>
                           
                            <div class="col-12">
                                <p>*El valor de la cuota mensual es estimado y no incluye valor del seguro.</p><br>
                            </div>
                            <!-- <div class="form-group">
                                <button class="theme_btn btn" id="js-contact-btn" type="submit">Enviar</button>
                                <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                            </div> -->
                        </div>
                    </form>
                </div>
                <div class="col-lg-5 text-center">
                    <div class="your_results">
                        <h3>Cuotas mensuales</h3>
                        <hr>
                        <p>Para saber las cuotas primero <br> ingresa todos los campos</p><br>
                        <div>
                            <h4 class="ra text-your_results">Cuota mensual</h4>
                            <h4><span>${{(form.vehiclePrice == 0 ? '--' : formatPrice(
                              ((form.vehiclePrice - form.vehicleHitch) / form.monthsNumber) + (((form.vehiclePrice - form.vehicleHitch) / 100) * TASA) + GPS + SEGURODEUDOR
                            ))}}</span></h4>
                        </div>
                        <div class="form">
                            <form>
                                <fieldset class="form__options">
                                    <p>Selecciona el número de meses*</p>
                                    <p class="form__answer">
                                        <input type="radio" name="match" id="match_1" value="12" v-model="form.monthsNumber">
                                        <label for="match_1">
                                            12
                                        </label>
                                    </p>
                                    <p class="form__answer">
                                        <input type="radio" name="match" id="match_2" value="24" v-model="form.monthsNumber">
                                        <label for="match_2">
                                            24
                                        </label>
                                    </p>
                                    <p class="form__answer">
                                        <input type="radio" name="match" id="match_3" value="36" v-model="form.monthsNumber">
                                        <label for="match_3">
                                            36
                                        </label>
                                    </p>
                                    <p class="form__answer">
                                        <input type="radio" name="match" id="match_4" value="48" v-model="form.monthsNumber" checked>
                                        <label for="match_4">
                                            48
                                        </label>
                                    </p>
                                </fieldset>
                            </form>
                        </div>
                        <div class="col-12 white-hr"><hr>
                        </div>
                        <div>
                            <h4 class="ra text-your_results">Monto a financiar</h4>
                            <h4 class="text-your_results_2">Precio del vehículo - enganche</h4>
                            <h4><span>${{(form.vehiclePrice == 0 ? '--' : formatPrice(form.vehiclePrice - form.vehicleHitch))}}</span></h4>
                        </div>
                        <div>
                            <h4 class="ra text-your_results">Enganche</h4>
                            <!-- <h4 class="ra text-your_results">Pagos de contado:</h4>
                            <h4 class="ra text-your_results">Comisión de apertura 2.5%</h4>
                            <h4 class="text-your_results_2">2.5% del valor del monto a financiar</h4> -->
                            <h4><span>${{(form.vehiclePrice == 0 ? '--' : formatPrice(form.vehicleHitch))}}</span></h4><br>
                            <!-- <h4><span>${{(form.vehiclePrice == 0 ? '--' : formatPrice(((form.vehiclePrice - form.vehicleHitch) / 100) * 2.5))}}</span></h4><br> -->
                        </div>
                        <div class="col-12 ">
                            <button class="theme_btn btn btn-block" style="width: 100%" 
                                    :disabled="$v.form.$invalid"
                                    v-on:click="createCreditQuotation()">Aplicar ahora</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Easy cash Area -->

    <!-- Map and From Area 
    <section class="inicio-contacto-2 map_from_area">
        <div class="map_area">
            <div class="map_content">
                <iframe src="https://www.google.com/maps/d/u/0/embed?mid=15t3qJqAwN9WTPYplZFk1lDq5Y4N_FqVK"
                    height="671" frameborder="0" style="border:0; width: 100%" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
        <div class="contact_inner contact-form-title">
            <form class="from_main" novalidate="novalidate">
                <h2>¿Tienes alguna pregunta que hacer? <br><span>por favor, escríbenos</span> </h2>
                <div class="form-group">
                    <input type="text" class="form-control" id="name" name="name" placeholder="Nombre" v-model="contactForm.name" :class="{ 'error': $v.contactForm.name.$invalid }">
                </div>
                <div class="form-group">
                    <input type="email" class="form-control" id="email" name="email" placeholder="Correo electrónico" v-model="contactForm.email" :class="{ 'error': $v.contactForm.email.$invalid }">
                </div>
                <div class="form-group">
                    <input type="text" class="form-control" id="subject" name="subject" placeholder="Asunto" v-model="contactForm.subject" :class="{ 'error': $v.contactForm.subject.$invalid }">
                </div>
                <div class="form-group">
                    <textarea class="form-control" id="message" name="message" placeholder="Mensaje" v-model="contactForm.text" :class="{ 'error': $v.contactForm.text.$invalid }"></textarea>
                </div>
                <div class="form-group">
                    <button class="theme_btn btn" id="js-contact-btn" type="button" v-on:click="sendContact()" :disabled="$v.contactForm.$invalid">Enviar</button>
                    <div id="js-contact-result" data-success-msg="Form submitted successfully." data-error-msg="Messages Successfully"></div>
                </div>
            </form>
        </div>
    </section>
    End Map and From Area -->
  </div>
</template>

<script>
  import { required, minLength, minValue, maxValue } from 'vuelidate/lib/validators';
  import Environments from '../environments/Environment';
  import createNumberMask from 'text-mask-addons/dist/createNumberMask';

  const numberMask = createNumberMask({
    prefix: '',
    includeThousandsSeparator: true,
    allowNegative: false,
  });

  export default {
    name: 'QuoteCredit',
    data() {
      return {
        TASA: Environments.TASA,
        GPS: Environments.GPS,
        SEGURODEUDOR: Environments.SEGURODEUDOR,
        numberMask,
        models: [],
        brands: [],
        versions: [],
        descriptions: [],
        porcentaje:0,
        masck:{
          vehiclePrice: 0,
          vehicleHitch: 0,
          monthlyIncome: 0,
          dependent:0,
        },
        form: {
          selectedModel: '',
          selectedBrand: '',
          selectedVersion: '',
          selectedDescription: '',
          vehiclePrice: 0,
          vehicleHitch: 0,
          monthlyIncome: 0,
          dependent:0,
          monthsNumber: 48
        },
        contactForm: {
          name: '',
          email: '',
          subject: '',
          text: '',
        }
      }
    },
    validations() {
      return {
        form: {
          //selectedModel: { required },
          //selectedBrand: { required },
          //selectedVersion: { required },
          //selectedDescription: { required },
          vehiclePrice: { required, minValue: minValue(1), $lazy: true },
          monthlyIncome: { required, minValue: minValue(1), $lazy: true },
          dependent: { required, $lazy: true },
          vehicleHitch: { required, minValue: minValue((this.form.vehiclePrice/100)*20), maxValue: maxValue(this.form.vehiclePrice), $lazy: true }
        },
        contactForm: {
          name: { required },
          email: { required },
          subject: { required },
          text: { required }
        }
      }
    },
    methods: {
      sendContact() {
        var data = {
          data: {
            name: this.contactForm.name,
            email: this.contactForm.email,
            subject: this.contactForm.subject,
            message: this.contactForm.text,
          }
        };
        this.$InsuranceService.sendContact(data).then((result) => {
          this.$swal('Exito, su petición ha sido enviada con exito');
          this.contactForm.name = '';
          this.contactForm.email = '';
          this.contactForm.subject = '';
          this.contactForm.text = '';
          window.scrollTo(0, 0);
        }, (err) => {
          this.$swal(err.msg);
        });
      },
      status(validation) {
    	  return validation.$invalid;
      },
      refreshSelects() {
        $('#model').niceSelect('update');
        $('#brand').niceSelect('update');
        $('#version').niceSelect('update');
        $('#description').niceSelect('update');
      },
      getModels() {
        this.$InsuranceService.getModels().then((result) => {
          this.models = result.data.model.slice(0,14);
          setTimeout(() => {
            this.refreshSelects();

            $('#model').on('change', () => {
              this.form.selectedModel = $('#model').val();
              $('#brand').val('');
              $('#version').val('');
              $('#description').val('');
              this.form.selectedBrand = '';
              this.form.selectedVersion = '';
              this.form.selectedDescription = '';

              this.getBrands();

              setTimeout(() => {
                this.refreshSelects();
              }, 100);
            });
          }, 100);
        }, (err) => this.$swal(err.msg));
      },
      getBrands() {
        if (this.form.selectedModel != '') {
          const data = {
            model: this.form.selectedModel
          };

          this.$InsuranceService.getBrands(data).then((result) => {
            this.brands = result.data.brand;

            setTimeout(() => {
              this.refreshSelects();

              $('#brand').on('change', () => {
                this.form.selectedBrand = $('#brand').val();
                $('#version').val('');
                $('#description').val('');
                this.form.selectedVersion = '';
                this.form.selectedDescription = '';

                this.getVersions();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => this.$swal(err.msg));
        }
      },
      getVersions() {
        if (this.form.selectedBrand != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand
          };

          this.$InsuranceService.getVersions(data).then((result) => {
            this.versions = result.data.version;

            setTimeout(() => {
              this.refreshSelects();

              $('#version').on('change', () => {
                this.form.selectedVersion = $('#version').val();
                $('#description').val('');
                this.form.selectedDescription = '';

                this.getDescriptions();
                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => this.$swal(err.msg));
        }
      },
      getDescriptions() {
        if (this.form.selectedVersion != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand,
            version: this.form.selectedVersion
          };

          this.$InsuranceService.getDescriptions(data).then((result) => {
            this.descriptions = result.data.description;

            setTimeout(() => {
              this.refreshSelects();

              $('#description').on('change', () => {
                this.form.selectedDescription = $('#description').val();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => this.$swal(err.msg));
        }
      },
      createCreditQuotation() {
          this.preloader();
          const data = {
            user_id: localStorage.getItem('id'),
            monthlyIncome: Number(this.form.monthlyIncome),
            dependent: Number(this.form.dependent),
            vehicle_price: Number(this.form.vehiclePrice),
            vehicle_hitch: Number(this.form.vehicleHitch),            
            months: Number(this.form.monthsNumber),
            vehicle_model: this.form.selectedModel,
            vehicle_brand: this.form.selectedBrand,
            vehicle_version: this.form.selectedVersion,
            vehicle_description: this.form.selectedDescription,
          };
          this.$UserService.createCreditQuotation({data: data}).then((result) => {
            let quote_credit = result.data.insertId;
            localStorage.setItem('quote_credit', quote_credit);  
            this.preloaderHiden();               
            this.$swal('Cotización de crédito','¡Se han mandado sus datos con éxito!', "success")
            .then(() => {
                window.location = '/create-account';
            });              
          }, (err) => {this.$swal(err.msg); this.preloaderHiden();});
      },
      formatPrice(value) {
          let num = (value/1).toFixed(2);
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      preloader(){        
        $('.preloader').fadeIn();
        $('.preloader').delay(10).fadeIn('slow');
      },
      preloaderHiden(){        
        $('.preloader').fadeOut();
        $('.preloader').delay(10).fadeOut('slow');
      }
    },
    created() {
      this.preloader();
      localStorage.removeItem('quote_credit');
      this.preloaderHiden();
      //this.getModels();
    },
  }
</script>

<style lang="scss">
  .error {
    border-color: red !important;
    background: #FDD;
  }

  .error:focus {
    outline-color: #F99;
  }

  .nice-select .current {
      width: -webkit-fill-available !important;
      display: block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/QuoteCredit.vue